import { Component, OnInit, Output , Input } from '@angular/core';
import { NgxDynamicTableConfig } from '../lib/interfaces/ngx-dynamic-table-config';
import { toUnicode } from 'punycode';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'ngx-dynamic-table',
  template: `<div class="title">
    <h3 class="title__name">
        {{ config.tableName }}
    </h3>
    <div class="paginate">
        {{from}}-{{ to }} of {{ total }}
    </div>
    <div class="btn-group">
        <button (click)="prev()" title="newer" [disabled]="disablePrev">&lt;</button>
        <button (click)="next()" title="older" [disabled]="disableNext">&gt;</button>
    </div>
</div>

<div class="table">
    <div class="table__row table__head">
      <div class="table__data" *ngFor="let header of config.tableHeaders">
        {{ header | uppercase }}
      </div>
    </div>
    <div class="table__row" *ngFor="let data of tableData">
      <div class="table__data" *ngFor="let header of config.tableHeaders">
        <span>
            {{ data[header] }}
        </span>
      </div>
    </div>
  </div>
  `,
  styles: [`.title{display:flex;align-items:center;padding:10px;border-bottom:1px solid #d0d0d0}.title__name{color:#8a2be2;padding:0;margin:0 auto 0 0}.paginate{margin-right:5px;font-size:14px}.btn-group>button{padding:3px 6px;font-weight:600;border:1px solid gray;border-radius:2px;cursor:pointer;outline:0}.btn-group>button:not(:last-child){margin-right:5px}.table{display:flex;flex-flow:column nowrap;font-size:.8rem;line-height:1.5;border-bottom:1px solid #d0d0d0;flex:1 1 auto}.table__head{display:none;font-weight:700;background-color:#f2f2f2}.table__head>.table__data{white-space:normal}.table__row{width:100%;display:flex;flex-flow:row nowrap}.table__row:nth-of-type(even){background-color:#f2f2f2}.table__row:nth-of-type(odd){background-color:#fff}.table__data{display:flex;flex-flow:row nowrap;flex-grow:1;flex-basis:0;padding:.5em;word-break:break-word;overflow:hidden;text-overflow:ellipsis;min-width:0;white-space:nowrap;border-bottom:1px solid #d0d0d0;justify-content:center}.table__data:first-child{justify-content:flex-start}.table__data:last-child{justify-content:flex-end}`]
})
export class NgxDynamicTableComponent implements OnInit {

  @Input()
  config: NgxDynamicTableConfig;
  from: number ;
  to: number;
  total: number;
  offset: number;
  disablePrev: boolean;
  disableNext: boolean;
  tableData: Array<any>;

  constructor() {
  }

  ngOnInit() {
    this.disablePrev = true;
    this.disableNext = false;
    this.from = 1;
    this.to = this.offset = this.config.tableOffset;
    this.total = this.config.tableData.length;
    // console.log();
    this.tableData = this.paginatedData();
  }
  next() {
    this.from += this.offset;
    this.to += this.offset;

    this.disableStatus();
    this.tableData = this.paginatedData();
  }

  prev() {
    this.from -= this.offset;
    this.to -= this.offset;
    this.disableStatus();
    this.tableData = this.paginatedData();
  }

  disableStatus() {
    if ((this.from - 1) <= 1) {
      this.disablePrev = true;
    } else {
      this.disablePrev = false;
    }

    if ((this.to + 1) >= this.total) {
      this.disableNext = true;
    } else {
      this.disableNext = false;
    }
  }

  paginatedData() {
    console.log(this.from, this.to);
    const data = this.config.tableData;
    return data.slice(this.from - 1, this.to);
  }
}
